import { Box } from "@mui/material";

/**
 * Render this inside a form to prevent Hubspot from tracking the form..
 * Usually all forms are tracked by Hubspot, especially when it contains email attribute, but this input will prevent that.
 *
 * https://community.hubspot.com/t5/Lead-Capture-Tools/Ignore-a-specific-non-Hubspot-form-from-being-collected/m-p/246957
 */
export default function HubspotAntiFormTracking() {
	return (
		<Box display="none">
			<label className="hidden">
				credit card HubspotCollectedFormsWorkaround
				https://community.hubspot.com/t5/APIs-Integrations/How-to-stop-collected-forms-from-collecting-a-form/m-p/299172#M28102
			</label>
			<input name="cc-num" className="hidden" required value="HubspotCollectedFormsWorkaround" id="cc-num" />
		</Box>
	);
}
